// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1BLN5","inputDescription":"styles_inputDescription__Bahii"};